unit f_ordini;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  f_ordinedettaglio, DateUtils, f_selezione, w_edit, un_servermodule, w_label,
  un_telemetria, UnArrayDef, DB, un_user;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 trasporti' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare i trasporti';
  msgNessunRecord = 'Nessun trasporto da visualizzare';
  msgCaricamentoInCorso = 'Nessun trasporto da visualizzare...';
//  msgCaricamentoInCorso = 'Caricamento trasporti in corso...';

type
  { TFrmOrdini }

  TFrmOrdini = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate :String;
    dt1str, dt2str :String;
    function DateOk:Boolean;
    procedure RefreshTrasporti; async;
    procedure QryTrasportiOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
    procedure SetLabelStampa;
  published
    procedure tab1_rowclick;
    procedure filtro_change;
    procedure filtro_input;
    procedure fltuttitrasporti_click; async;
    procedure data1_change;
    procedure data2_change;
    procedure stampa1_click(event: TJSEvent); async;
    stampa1 :TJSHTMLButtonElement;
//    procedure link3_click(event: TJSEvent); async;
    data1 : TJSHTMLInputElement;
    data2 : TJSHTMLInputElement;
    filtro: TWEdit;
    edit2: TJSHTMLInputElement;
    pnltab1: TJSHTMLElement;
//    link3: TJSHTMLAnchorElement;
    QryTrasporti: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
    fltuttitrasporti:TJSHTMLInputElement;
  end;

implementation

{$R *.html}

{ TFrmOrdini }

procedure TFrmOrdini.AfterRender;
begin
  QryTrasporti.OnFilterRecord := @QryTrasportiOnFilterRecord;

  filtro.placeholder := 'Ricerca trasporti...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';


  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';


  data1.value := window.localStorage[ClassName+'_data1'] ;
  data2.value := window.localStorage[ClassName+'_data2'] ;

  fltuttitrasporti.checked:=false;

  RefreshTrasporti;

end;


procedure TFrmOrdini.QryTrasportiOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;



procedure TFrmOrdini.SetLabel(lbl:TWLabel;value:String);
begin
  lbl.Visible :=   value <> '' ;
  lbl.labelbody.innerHTML := value;
end;

procedure TFrmOrdini.SetLabelStampa;
var
  RecordCount: Integer;
begin
  if not QryTrasporti.Active then
    exit;

  RecordCount := 0;
  QryTrasporti.First;
  while not QryTrasporti.EOF do
  begin
    Inc(RecordCount);
    QryTrasporti.Next;
  end;
  stampa1.innerHTML:= format('Stampa (%d %s)'
      ,[RecordCount, IfThen(RecordCount = 1,'ordine','ordini') ]);
end;

procedure TFrmOrdini.ImpostaVisibilita(visibilita: TVisibilita);
begin
  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabelStampa;
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible :=  visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];
end;

procedure TFrmOrdini.RefreshTrasporti;
begin

  //SetLabel(labelTop,'');
  //messaggio.Visible := true;
  //pnltab1.Visible := false;
  //idempty.Visible:= false;
  //idlink.Visible:= false;
  //msgLimite.Visible := false;

  if not DateOk then
  begin
    ImpostaVisibilita(visDateErrate);
    exit;
  end;
  ImpostaVisibilita(visCaricamentoInCorso);
  QryTrasporti.Close;
  QryTrasporti.SQL.Text:=  'select dtdata as data, horapartenza as orap, horaarrivo as entrole, '
                      + ' dsautista as autista, dsaccompagnatore as accomp, dsautomezzo as mezzo, '
                      + ' dstiporichiesta as rich, dsfruitore as partenza, dsindirizzopartenza as indpartenza, '
                      + ' dsfruitore2 as arrivo, dsindirizzoarrivo as indarrivo, dstelefono as telef, dsnote as note '
                      + ' from ta_trasporti '
                      + ' where idsocieta = ''DON001'' '
                      + ' and ' + whereDate;
  if not fltuttitrasporti.checked then
  begin
    QryTrasporti.SQL.Text := QryTrasporti.SQL.Text
      + ' and (idautista = ' + user.QryUtenti.FieldByName('idanagrafica').AsString
      + ' or idaccompagnatore = ' + user.QryUtenti.FieldByName('idanagrafica').AsString + ')';
  end;
  QryTrasporti.SQL.Text := QryTrasporti.SQL.Text + ' order by dtdata, dsautista, horapartenza ';
  AWait(QryTrasporti.Open);
//  QryTrasporti.FieldByName('id_ordine').Visible:= false;
  console.log(format('QryTrasporti.RecordCount=%d',[QryTrasporti.RecordCount]));

  RefreshFiltro;
end;

procedure TFrmOrdini.RefreshFiltro;
begin
  QryTrasporti.Filtered:= filtro.value.Trim <> '';
  QryTrasporti.First;
  tab1.RenderDataSet(QryTrasporti);

  if QryTrasporti.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryTrasporti.RecordCount = limiteRecord  then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);
end;

procedure TFrmOrdini.filtro_change;
begin
  RefreshFiltro;
end;

procedure TFrmOrdini.filtro_input;
begin
  RefreshFiltro;
end;

procedure TFrmOrdini.fltuttitrasporti_click;
begin
  Console.Log('parte');
  RefreshTrasporti;
end;

procedure TFrmOrdini.tab1_rowclick;
var
  instance: TFrmOrdineDettaglio;
begin

//  instance := TFrmOrdineDettaglio.Create();
//  instance.idordine := QryTrasporti.FieldByName('id_ordine').AsInteger ;
//  instance.show;

end;

procedure TFrmOrdini.data1_change;
begin

  window.localStorage[ClassName+'_data1'] := data1.value;

  RefreshTrasporti;

end;

procedure TFrmOrdini.data2_change;
begin

  window.localStorage[ClassName+'_data2'] := data2.value;

  RefreshTrasporti;

end;

procedure TFrmOrdini.stampa1_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '116';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

//  clausola := format( 'AND O.ID_ORDINE IN (%s)',[ ToCommaText(QryTrasporti,'ID_ORDINE',true) ]);
//  sql := SysUtils.StringReplace(sql,'--AND1',clausola,[]);

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '116';
    Params['sql'] := sql;
    Params['DATADA'] := dt1str;
    Params['DATAA'] :=  dt2str;
    window.open(Url,'_blank');
  end;
  TmRegistraEvento('stampa_ordini',format('%s ~ %s|stato=%s|filtro=%s'
  ,[data1.value,data2.value,filtro.Value]));
  //idstato.value,
end;

//procedure TFrmOrdini.link3_click(event: TJSEvent);
//begin
//
//  if QryTrasporti.RecordCount < 1 then
//  begin
//    ShowMessage('prima di stampare devi eseguire la query...');
//    exit;
//  end;
//
//  with ServerModule('TWebStampe') do
//  begin
//    Proc := 'WebProcessa';
//    Params['idStampa'] := '89';
//    Params['sql'] := ' select * from ord_ordinimarketing '
//     + ' where mel_idsocieta = ''DON001'' '
//     + ' and ' + whereDate;
//   if idstato.value <> '' then
//   begin
//    Params['sql'] := Params['sql'] + ' and mel_dsstato = ' + '''' + idstato.value + ''''
//   end;
//  Params['sql'] := Params['sql'] + ' order by data ';
//  link3.href := Url;
//  link3.target := '_blank';
//  end;
//
//end;

function TFrmOrdini.DateOk: Boolean;
var
  dt1, dt2: TDateTime;
begin

  Result :=  false;

  if (data1.value = '') or (data2.value = '')
    or (data1.value > data2.value) then
  begin
    SetLabel(labelTop,msgDateErrate);
    SetLabel(labelBottom,'');
    exit;
  end;

  Result :=  true;

  dt1 := ScanDateTime('yyyy-MM-dd',data1.value);
  dt2 := ScanDateTime('yyyy-MM-dd',data2.value) ;
  dt2 := IncDay(dt2);

// questo formato date serve per la query
  dt1str := FormatDateTime('dd.MM.yyyy',dt1);
  dt2str := FormatDateTime('dd.MM.yyyy',dt2);

  whereDate := ' dtdata >= ''' + dt1str + ''''
    + ' and dtdata < ''' + dt2str + '''';

// questo formato di date serve alla stampa
  dt1str := FormatDateTime('dd/MM/yyyy',dt1) + ' 00:00:00';
  dt2str := FormatDateTime('dd/MM/yyyy',dt2) + ' 00:00:00';

end;

initialization
  RegisterWeb(TFrmOrdini);

end.

